import * as types from "../actions/actionTypes"
const initialState = {
	loading: true,
	data: { data: [], message: [] }
};

const Calendar = (state = initialState, action) => {
	switch (action.type) {
		case types.GET_CALENDAR_DATA_REQUEST:
			return { ...state, loading: true };
		case types.GET_CALENDAR_DATA_SUCCESS:
			return { ...state, ...action.payLoad };
		case types.GET_CALENDAR_DATA_FAILURE:
			return { ...state, ...action.payLoad };
		default:
			return state;
	}
};

export default Calendar;